import React, { useState } from "react";
import bannerVideo from "../../Assets/video/pearlTowersOfficial.mp4";
import "./heroSection.css";
import {
  Container,
  Grid,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
} from "@mui/material";
const countryCodes = [
  { code: "+92", country: "Pakistan" },
  { code: "+1", country: "US/Canada" },
  { code: "+44", country: "UK" },
  { code: "+91", country: "India" },
];
const interest = [
  { id: 1, label: "Tower 1: 4 Bed -A, Area: 3,113.25 sq.ft" },
  { id: 2, label: "Tower 2: 4 Bed -A, Area: 3,113.25 sq.ft" },
  { id: 3, label: "Tower 3: 3 Bed -B, Area: 2,562.50 sq.ft" },
  { id: 4, label: "Tower 4: 3 Bed -A, Area: 3,197.25 sq.ft" },
  { id: 5, label: "Tower 4: 3 Bed -C, Area: 2,804.25 sq.ft" },
  { id: 6, label: "Tower 5: 3 Bed -A, Area: 3,197 sq.ft" },
  { id: 7, label: "Tower 5: 3 Bed -C, Area: 2,886 sq.ft" },
  { id: 8, label: "Tower 6: 3 Bed -B, Area: 2,562.25 sq.ft" },
];
const HeroBanner = () => {
  const [selectedCountryCode, setSelectedCountryCode] = useState(
    countryCodes[0].code
  );
  const [selectInterest, setSelectInterest] = useState("Layout of Interest*");
  const handleCountryCodeChange = (event) => {
    setSelectedCountryCode(event.target.value);
  };
  const handleInterestChange = (event) => {
    setSelectInterest(event.target.value);
  };
  return (
    <div className="videoWrapper">
      <div className="overlay"></div>
      <video id="background-video" loop autoPlay muted className="videoComp">
        <source src={bannerVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="textContainer">
        <Container>
          <Grid container spacing={16}>
            <Grid item xs={12} md={6} alignSelf="center">
              <Typography variant="h2" className="heroTitle">
                Distinctive Homes
                <br />
                Timeless Elegance &<br />
                Unmatched Experiences Await
                <br />
                at Pearl Towers Lahore
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="formWrapper">
                <Typography variant="h2">Get in touch!</Typography>
                <Typography variant="p">
                  We would love to hear from you and answer any questions you
                  may have!
                </Typography>
                <div className="nameWrapper">
                  <div className="nameInput">
                    <TextField
                      hiddenLabel
                      id="filled-hidden-label-small"
                      placeholder="Email"
                      variant="filled"
                      size="small"
                      className="inputField"
                      fullWidth
                    />
                  </div>
                  <div className="nameInput">
                    <TextField
                      hiddenLabel
                      id="filled-hidden-label-small"
                      placeholder="Email"
                      variant="filled"
                      size="small"
                      className="inputField"
                      fullWidth
                    />
                  </div>
                </div>
                <div className="phoneWrapper">
                  <div>
                    <FormControl
                      variant="filled"
                      size="small"
                      className="inputField countryCode"
                    >
                      <Select
                        value={selectedCountryCode}
                        onChange={handleCountryCodeChange}
                        inputProps={{ id: "select-country-code" }}
                        renderValue={(value) => value}
                      >
                        {countryCodes.map((country) => (
                          <MenuItem key={country.code} value={country.code}>
                            {country.code} ({country.country})
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="testClass">
                    <TextField
                      hiddenLabel
                      id="filled-hidden-label-small"
                      placeholder="Email"
                      variant="filled"
                      size="small"
                      className="inputField phoneField"
                    />
                  </div>
                </div>
                <FormControl
                  variant="filled"
                  size="small"
                  className="inputField interestField"
                >
                  <Select
                    value={selectInterest}
                    onChange={handleInterestChange}
                    inputProps={{ id: "select-interest" }}
                    renderValue={(value) => value}
                  >
                    {interest.map((intrst) => (
                      <MenuItem key={intrst.id} value={intrst.label}>
                        {intrst.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  hiddenLabel
                  id="filled-hidden-label-small"
                  placeholder="Message"
                  variant="filled"
                  size="small"
                  multiline
                  rows={3}
                  fullWidth
                  className="inputField"
                />
                <Button variant="contained" className="submitBtn">
                  Send
                </Button>
                <Typography
                  sx={{
                    marginTop: "5%",
                    fontSize: "12px",
                  }}
                >
                  Please fill the form, our team will get back to you soon
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  );
};

export default HeroBanner;
